import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {deleteItem} from "../../../app/setters/deleteItem.js";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";

export const useUsunProjekt = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => deleteItem(`/${MAIN_REJESTR_API_SHORT}/${id}`),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
    });
};
